import type { BrandVoiceOwner } from '../../../modules/ai/brand-voice'

let current: BrandVoiceOwner | undefined

/** Makes the open owner the one the console helpers act on. Returns the way to let go of it. */
export const registerBrandVoiceOwner = (owner: BrandVoiceOwner): (() => void) => {
    current = owner

    return () => {
        if (current === owner) {
            current = undefined
        }
    }
}

/** The owner of the Brand Voice page that is open, or none. */
export const currentBrandVoiceOwner = (): BrandVoiceOwner | undefined => current
